"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
require("cn-next/es/menu/style");
var _menu = _interopRequireDefault(require("cn-next/es/menu"));
var _react = _interopRequireDefault(require("react"));
/**
 * 无数据时渲染
 */
var _default = function _default(props) {
  var prefix = props.prefix,
    notFoundContent = props.notFoundContent,
    locale = props.locale;
  return /*#__PURE__*/_react["default"].createElement(_menu["default"], {
    className: prefix + "cascader-select-not-found"
  }, /*#__PURE__*/_react["default"].createElement(_menu["default"].Item, null, 'notFoundContent' in props ? notFoundContent : /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, locale.notFoundContent)));
};
exports["default"] = _default;
module.exports = exports.default;
module.exports.default = exports.default;